import { render, staticRenderFns } from "./PlaneView.vue?vue&type=template&id=5747c7f6&scoped=true"
import script from "./PlaneView.vue?vue&type=script&lang=js"
export * from "./PlaneView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5747c7f6",
  null
  
)

export default component.exports